import { Badge, MantineColor } from "@mantine/core";
import { createStyles } from "@mantine/emotion";
import { MatchScoreStatus } from "../../../../../gql/graphql";

const useStyles = createStyles(() => ({
  badge: {
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
  },
}));

// Map score status to colors and labels
const statusConfig: Record<
  MatchScoreStatus,
  { color: MantineColor; label: string }
> = {
  [MatchScoreStatus.Winner]: { color: "green", label: "Winner" },
  [MatchScoreStatus.Loser]: { color: "rose", label: "Loser" },
  [MatchScoreStatus.Forfeit]: { color: "rose", label: "Forfeit" },
  [MatchScoreStatus.Waiting]: { color: "dark", label: "Waiting" },
  [MatchScoreStatus.Draw]: { color: "gray", label: "Draw" },
};

interface ScoreStatusBadgeProps {
  status: MatchScoreStatus;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  variant?: "filled" | "light" | "outline" | "dot";
}

export const ScoreStatusBadge = ({
  status,
  size = "sm",
  variant = "light",
}: ScoreStatusBadgeProps) => {
  const { classes } = useStyles();
  const config = statusConfig[status];

  return (
    <Badge
      className={classes.badge}
      color={config.color}
      size={size}
      variant={variant}
    >
      {config.label}
    </Badge>
  );
};

// Also export the config for use in other components
export const getScoreStatusConfig = (status: MatchScoreStatus) =>
  statusConfig[status];
